import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import AuthLeftPanel from '../../common/AuthLeftPanel';
import leftImage from '../../../assets/images/left-image-3.jpg';

const ForgotPasswordPage = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                height: { xs: 'auto', md: '100vh' },
                minHeight: '100vh',
                alignItems: 'stretch',
                padding: '24px',
                gap: '24px',
                background: '#F5F7F9',
                boxSizing: 'border-box',
                overflow: { xs: 'auto', md: 'hidden' }
            }}
        >
            <AuthLeftPanel image={leftImage} />

            <Box
                sx={{
                    flex: 1.1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: { xs: '30px 20px 24px 20px', md: '40px 0 24px 0' },
                    boxSizing: 'border-box'
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default ForgotPasswordPage;
